/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type BaseRequestOptionsArgs, type HttpResponse, HttpService, UNPLACEHOLDER, UtilService } from '@dm/core';
import { MO } from 'app/common/constants';
import { type Observable } from 'rxjs';

import { DetailI18nService } from './detail.str.service';

@Injectable({
    providedIn: 'root',
})
export class HardwareDetailService {
    constructor(
        private i18n: DetailI18nService,
        private util: UtilService,
        private http: HttpService,
    ) {

    }

    mo = MO;

    renderRunningSpeed = (speed): string | number => {
        if (!speed || speed.indexOf('4294967') !== -1 || speed.indexOf('-1') !== -1) {
            return UNPLACEHOLDER;
        }
        return speed / 1000;
    };

    renderConfigSpeed = (configSpeed): string | number => {
        if (!configSpeed || configSpeed.indexOf('4294967') !== -1 || configSpeed.indexOf('-1') !== -1) {
            return UNPLACEHOLDER;
        } else {
            if (configSpeed === '0') {
                return this.i18n.autoAdaptionValue;
            } else {
                return configSpeed / 1000;
            }
        }
    };

    // decode内容，避免特殊字符被转义；html中使用pre-wrap类来显示空格、换行等
    renderElabel = (elabel): string => elabel ? this.util.decodeHTML(elabel) : UNPLACEHOLDER;

    getInterfaceModuleData(id: string, opt?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('intfModule.get').format({ id });
        return this.http.get(rest, opt);
    }
}
